import { lazy } from 'react';

const loadLogin = () => import('./LoginPage');

/* eslint-disable import/prefer-default-export */
export const AppLogin = lazy(loadLogin);
